

export class BucketdeletefolderForm {
  public folderName: number;

  constructor(bucketdeletefolderForm: any) {
    this.folderName = bucketdeletefolderForm;
  }
}
